import { ChevronRight } from 'lucide-react';

interface Props {
  themes: Array<string>;
  onClick: () => void;
}

export function ThemesButton({ themes, onClick }: Props) {
  const count = themes.length;

  if (count === 0) {
    return (
      <div className="flex min-h-10 flex-1 items-center gap-2 rounded-md border border-transparent bg-transparent px-3 py-2 text-sm opacity-50">
        <div className="flex flex-1 flex-col items-start gap-1 leading-none">
          <div className="text-sm leading-none font-medium">-</div>
        </div>
      </div>
    );
  }

  const MAX_VISIBLE_NAMES = 1;
  const visibleThemes = themes.slice(0, MAX_VISIBLE_NAMES);
  const remaining = count - MAX_VISIBLE_NAMES;
  const hasMore = remaining > 0;

  const countText = count === 1 ? '1 theme' : `${count} themes`;

  return (
    <div className="flex items-center">
      <div
        data-theme-button
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        className="border-border flex min-h-10 w-50 cursor-pointer items-center gap-2 rounded-md border bg-white px-3 py-2 text-sm hover:bg-gray-50"
      >
        <div className="flex flex-1 flex-col items-start gap-1 leading-none">
          <div className="text-sm leading-none font-medium">{countText}</div>
          <div className="text-muted-foreground flex gap-1 text-xs leading-none">
            <div className="max-w-30 truncate">{visibleThemes.join(', ')}</div>
            <div className="flex-1">{hasMore && ` +${remaining}`}</div>
          </div>
        </div>
        <ChevronRight className="text-muted-foreground h-4 w-4 shrink-0" />
      </div>
    </div>
  );
}
